import * as React from "react";
import { container, logoLink, styledRow } from "./BrandBar.module.scss";
import { Link } from "gatsby";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const LogoLink: React.FC<any> = (props) => {
  return (
    <Link id={props.id} {...props} className={logoLink}>
      {props.children}
    </Link>
  );
};
export const StyledRow: React.FC<any> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <div
      className={`${styledRow} brandBar`}
      style={
        props.footer
          ? {
              paddingRight: isMobileOnly ? "" : "0",
              justifyContent: isMobileOnly ? "center" : "end",
            }
          : {}
      }
    >
      {props.children}
    </div>
  );
};
